<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
    <material-card :title="title">
      <material-notification
        v-if="false"
        class="my-3"
        color="primary"
        icon="mdi-information-outline"
      >
        Added contact for email {{ email }}. An email has been sent to {{ $store.state.user.email }} containing their credentials.
      </material-notification>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-form-base
          :model="item"
          :col="{ cols:12 }"
          :schema="schema"
          @change="change"
        />
      </v-form>
      <template v-slot:actions>
        <v-spacer />
        <v-btn
          color="primary"
          :loading="loading"
          @click="submit"
        >
          {{ title }}
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
      </template>
    </material-card>
  </v-dialog>
</template>

<script>
  import VFormBase from 'vuetify-form-base'
  export default {
    components: {
      VFormBase
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      schema: {
        type: Object,
        required: true
      },
      item: {
        type: Object,
        default: () => { return {} }
      }
    },
    data () {
      return {
        valid: true,
        dialog: false,
        loading: false
      }
    },
    methods: {
      open () {
        this.dialog = true
      },
      change ({ on, key, obj, params }) {
        // test event is 'click' and comes from appendIcon on key 'firstPassword'
        if (on === 'click' && key === 'password' && (params && params.tag) === 'append') {
          // toggle icon
          obj.schema.appendIcon = obj.schema.type === 'password' ? 'mdi-eye-off' : 'mdi-eye'
          // toggle visibility
          obj.schema.type = obj.schema.type === 'password' ? 'text' : 'password'
        }
      },
      submit () {
        if (this.$refs.form.validate()) {
          this.loading = true
          this.$emit('submit', {
            item: this.item,
            done: () => {
              this.loading = false
              this.dialog = false
            }
          })
        }
      }
    }
  }
</script>
